var noop = function noop() {
  return undefined;
};

export { noop };
//# sourceMappingURL=noop.js.map
